import type { Periodo } from '@/lib/supabase/tipos-bd'
import { lunesDe } from '@/modules/tablero/semana'

/**
 * Los bordes del periodo que contiene un día: la semana de lunes a domingo,
 * el mes o el año. Las mismas reglas del tablero, para que «esta semana» sea
 * la misma semana en las dos pantallas.
 */
export function bordes(periodo: Periodo, dia: string): { desde: string; hasta: string } {
  const [a, m] = dia.split('-').map(Number)
  if (periodo === 'año') return { desde: `${a}-01-01`, hasta: `${a}-12-31` }
  if (periodo === 'mes') {
    const ultimo = new Date(Date.UTC(a, m, 0)).getUTCDate()
    const mm = String(m).padStart(2, '0')
    return { desde: `${a}-${mm}-01`, hasta: `${a}-${mm}-${String(ultimo).padStart(2, '0')}` }
  }
  const desde = lunesDe(dia)
  const fin = new Date(Date.parse(`${desde}T00:00:00Z`) + 6 * 86_400_000)
  return { desde, hasta: fin.toISOString().slice(0, 10) }
}

/** El día en Cartago de una marca de tiempo, como aaaa-mm-dd. */
export function diaEnCartago(iso: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(iso))
}
